import type { BookingReservationInvoiceLookup } from '../Types/bookingReservationTable.types';

export interface ReservationInvoiceLookupShape {
  id: number;
  number: string;
  typeLabel: string;
  sortOrder: number;
  issueDate: string;
  totalGross: number | null;
  currency?: string | null;
}

export const mapReservationInvoiceToBookingReservationInvoiceLookup = (
  invoice: ReservationInvoiceLookupShape | undefined | null
): BookingReservationInvoiceLookup | undefined => {
  if (!invoice) {
    return undefined;
  }

  return {
    id: invoice.id,
    number: invoice.number,
    typeLabel: invoice.typeLabel,
    sortOrder: invoice.sortOrder,
    issueDate: invoice.issueDate,
    totalGross: invoice.totalGross,
    currency: invoice.currency,
    sourceType: 'invoice-api',
  };
};
